export default __webpack_public_path__ + "static/media/lipata_hazard_map2.784896f8.jpg";